import { useState } from "react";
import { Container } from "react-bootstrap"
import MexForm from "../autoagendamientov2/mexico/MexForm";
import CardDinamic from "../autoagendamientov2/CardDinamic";
import { declinadoConsentimientoTLS, linkObsolete, mexReservadoOK } from "../../pages/autoagendamiento/AutoagendamientoV2";
import MexEspecialidad from "../autoagendamientov2/mexico/MexEspecialidad";
import ConfirmarServicio from "../autoagendamientov2/ConfirmarServicio";
import { ThemeProvider } from "styled-components";
import useTheme from "../../hook/useTheme";
import { AutoagendamientoV2Styles } from "../../theme/AutoagendamientoV2Styles";
import HeaderTop from "../autoagendamientov2/HeaderTop";
import AutoagendmientoFooter from "../autoagendamientov2/AutoagendmientoFooter";
import Banner1 from "../autoagendamientov2/Banner1";
import Banner2 from "../autoagendamientov2/Banner2";
import { useEffect } from "react";

export default function AutoagendamientoOnDemandV2({cita, onDemand, source}){
    const [currentScreen, setCurrentScreen] = useState("mexFormPatient")
    const [currentBanner, setCurrentBanner] = useState('')    
    const {theme} = useTheme("defaultv2");
    const [dataHelp, setDataHelp] = useState({
        patient: null,
        validLink: true,
        startMeeting: null,
        currentTime:null,
        clientTime: Date.now(),
        reservadoExitosamente: false,
        isPedienteAprobacion: false,
        notEdit: false,
        fieldSettings: [],
        declined: false,
        source: 'autoagendamientocat',
        configuration:null,
        payment: null,
        paymentStatus: 'currentflow',
        linkAllianz: true
    })

    const screens = {
        linkObsolote: <CardDinamic children={linkObsolete}></CardDinamic>,
        mexFormPatient: <MexForm classTop="mt--20" data={dataHelp} setData={setDataHelp} setCurrentScreen={setCurrentScreen}/>,
        mexEspecialidad: <MexEspecialidad classTop="mt--20" data={dataHelp} setData={setDataHelp} setCurrentScreen={setCurrentScreen}/>,
        confirmarServicio: <ConfirmarServicio classTop="mt--20" data={dataHelp} setData={setDataHelp} setCurrentScreen={setCurrentScreen}/>,
        mexReservadoOK: <CardDinamic children={mexReservadoOK}></CardDinamic>,
        declinadoConsentimientoTLS: <CardDinamic children={declinadoConsentimientoTLS}></CardDinamic>,
    }
    const banners = {
        banner1: <Banner1 />,
        banner2: <Banner2 />,
    }

    useEffect(()=> {
        if(currentScreen === 'mexFormPatient'){
            setCurrentBanner('banner2')
        }else if(
            currentScreen === 'mexEspecialidad' ||
            currentScreen === 'confirmarServicio'
        ){
            setCurrentBanner('banner1')
        }else{
            setCurrentBanner('')
        }
    },[currentScreen])


    return (
        <ThemeProvider theme={ theme }>
            <AutoagendamientoV2Styles />
            <div className="body-1">
                <HeaderTop />
                {banners[currentBanner]}
                <main>
                    <Container>
                        {screens[currentScreen]}                    
                    </Container>
                </main>
                <AutoagendmientoFooter />
            </div>
        </ThemeProvider>       
    );
}